/* Zumpo/Lives. The label is ink on paper, cream and the tinted panels alike. */
.lives {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: var(--zumpo-space-8);
  color: var(--zumpo-ink);
}

.hearts {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-4);
}

.heart {
  flex: none;
  fill: var(--zumpo-line);
}

.full {
  fill: var(--zumpo-coral);
}

.label {
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
  white-space: nowrap;
}
